<template>
    <div>
        <div class="float-container--bottom card card-floating">
            <button @click="closeCard" class="close-button">
                <svg-item :size="32" :icon="'cerrar'" :color="'--main-color'"></svg-item>
            </button>
            <div v-if="preFormattedOptions && preFormattedOptions.length">
                <div v-for="opt in preFormattedOptions">
                    <input type="radio" :value="opt.key" :id="'cancel_' + opt.key" name="cancel_reason" class="radio-button" v-model="reasonOption" />
                    <label :for="'cancel_' + opt.key" class="radio-button-click-target">
                        <span class="radio-button-circle"></span>
                        {{ opt.value }}
                    </label>
                </div>
            </div>
            <div class="form-input-wrapper" v-else>
                <label class="form-label" for="txt_reason"><h1 v-lang.cancelReason>Razón de cancelación</h1></label>
                <textarea v-jump:click.blur="'btn_cancel'" class="form-input" maxlength="140" type="text" id="txt_reason" ref="txt_reason" v-model='reasonText' :class="{'has-error': reasonError.state }"></textarea>
            </div>
            <div class="error" v-if="reasonError.state">
                {{ reasonError.message }}
            </div>
            <button id="btn_cancel" ref="btn_cancel" class="btn btn-secondary btn-lg btn-heavy" @click="cancelTrip"> <span v-if="!loading" v-lang.cancelar> Cancelar </span> <loader :flag="loading"> </loader> </button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Error from '@/services/inputError';
import { getPreformattedCancelationOptions } from '@/services/utility';
import Forms from '../mixins/forms';

export default {
    name: 'cancelCard',
    data () {
        return ({
            reasonText: '',
            reasonError: new Error(),
            loading: false,
            reasonOption: null
        });
    },
    computed: {
        ...mapGetters({
            settings: 'company/config',
            isDriver: 'auth/isChofer'
        }),
        preFormattedOptions () {
            return getPreformattedCancelationOptions(this.settings.razones_cancelacion, this.isDriver, this.language);
        }
    },
    mounted () {
        this.language = this.$getLang();
    },
    methods: {
        cancelTrip () {
            if (this.preFormattedOptions && this.preFormattedOptions.length) {
                console.log('this.reasonOption', this.reasonOption);
                if (this.reasonOption) {
                    this.loading = true;
                    let reasonText = this.preFormattedOptions.find(o => o.key === this.reasonOption).value;
                    console.log('reasonText', reasonText);
                    this.$emit('cancel_trip', reasonText, this.reasonOption);
                } else {
                    this.reasonError.state = true;
                    this.reasonError.message = this.translate('reasonShortMessage');
                    this.jumpToError();
                }
            } else {
                if (this.reasonText.length > 0) {
                    this.loading = true;
                    this.$emit('cancel_trip', this.reasonText);
                } else {
                    this.reasonError.state = true;
                    this.reasonError.message = this.translate('reasonShortMessage');
                    this.jumpToError();
                }
            }
        },
        closeCard () {
            this.$emit('close_card');
        }
    },
    watch: {
        reasonText () { this.reasonError.state = false; }
    },
    mixins: [Forms]
};
</script>

<style scoped>
    .close-button {
        background: transparent;
        position: absolute;
        right: 5px;
        top: 1em;
        border: 0;
        z-index: 10;
    }
    .form-input-wrapper {
        margin-top: .2em;
    }
    .form-input-wrapper .form-input {
        margin-top: 1.4em;
        border: 1px solid var(--text-color);
        height: 7em;
        padding: 1em;
        height: 8.2em;
    }
    .form-input-wrapper .form-input.has-error {
        border-color: red;
    }
    span.error {
        display: block;
        font-size: 12px;
        margin-top: -5px;
        color: red;
        font-weight: bold;
    }
    .form-input-wrapper .form-label {
        width: calc(100% - 30px);
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/CancelCard.vue